export default [
  {
    fullName: 'Марк Шевченко',
    description: 'ведущий разработчик, Холдинг Т1',
    photo: require('@/assets/speakers/speaker-7.jpg')
  },
  {
    fullName: 'Анна Савиновских',
    description: 'ведущий разработчик Группы «Иннотех», Холдинг Т1',
    photo: require('@/assets/speakers/speaker-4.jpg')
  },
  {
    fullName: 'Алексей Сидоркин',
    description: 'архитектор Группы «Иннотех», Холдинг Т1',
    photo: require('@/assets/speakers/speaker-1.jpg')
  },
  {
    fullName: 'Антон Стеканов',
    description: 'senior Java-разработчик',
    photo: require('@/assets/speakers/speaker-3.jpg')
  },
  {
    fullName: 'Паша Коршиков',
    description: 'лидер сообщества разработчиков, Холдинг Т1',
    photo: require('@/assets/speakers/speaker-5.jpg')
  }
]
